import styled from '@emotion/styled';
import { sizes } from '@sharefiledev/antd-config';
import { GlobalToken, Modal } from 'antd';

export const StyledModal = styled(Modal)<{
	token: GlobalToken;
}>`
	@media (max-width: ${props => props.token.screenMD}px) {
		max-width: calc(100vw - ${sizes.XL}) !important;
	}

	.ant-modal-content {
		@media (max-width: ${props => props.token.screenXS}px) {
			margin: ${sizes.base};
			width: fit-content !important;
		}
	}
`;
